import React from "react";
import { Link } from "gatsby";
import start1 from "../../static/images/project-start1.png";
import shape9 from "../../static/images/shape/vector-shape9.png";
import shape10 from "../../static/images/shape/vector-shape10.png";

const StartProject = () => {
  return (
    <section className="cta-area ptb-100">
      <div className="container">
        <div className="cta-box">
          <div className="row align-items-center g-4">
            <div className="col-lg-6 col-md-12 order-2 order-lg-1">
              <div className="cta-content">
                <h2>
                  Start With the Microsoft Cloud Improvements Most Likely to Move the Business Forward
                </h2>

                <p className="cta-lead">
                  Microsoft 365 can improve collaboration, security, governance,
                  automation, and operational control, but only when it is
                  planned and configured properly. CloudLogic helps identify the
                  best next steps before you invest time and budget.
                </p>

                <ul className="cta-list">
                  <li>
                    Review Microsoft 365, Azure, SharePoint, Teams, and licensing
                  </li>
                  <li>
                    Prioritise collaboration, automation, security, and governance improvements
                  </li>
                  <li>
                    Receive a plain-English transformation roadmap for leadership
                  </li>
                </ul>

                <div className="cta-actions">
                  <Link to="/contact" className="default-btn">
                    Book Microsoft 365 Health Check
                  </Link>

                  <span className="cta-note">
                    Modern workplace • Security-aware • Governance-ready
                  </span>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-12 order-1 order-lg-2">
              <div className="cta-image">
                <img
                  src={start1}
                  alt="Microsoft cloud transformation governance and managed IT support"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="vector-shape9">
        <img src={shape9} alt="" />
      </div>

      <div className="vector-shape10">
        <img src={shape10} alt="" />
      </div>
    </section>
  );
};

export default StartProject;
